const LABELS = { nuevo: "Nuevo", contactado: "Contactado", interesado: "Interesado", propuesta_enviada: "Propuesta enviada", inscrito: "Venta", perdido: "Perdido" };
export const ETAPA_VENTA_CERRADA = "inscrito";
export const DEFAULT_STAGES = Object.keys(LABELS);
export const etapaLabel = (config, id) => config?.etapasCatalogo?.find(e => e.id === id)?.nombre || LABELS[id] || id;

/** Catalog visibility is authoritative; legacy rows without activa remain visible. */
export function etapasVisiblesPipeline(config = {}) {
  if (config?.etapasCatalogo?.length) {
    return config.etapasCatalogo.filter(stage => stage.activa !== false);
  }
  return (config?.etapasPipeline || DEFAULT_STAGES).map(id => ({ id, nombre: etapaLabel(config, id) }));
}

const CANAL_LABELS = { whatsapp: "WhatsApp", presencial: "Presencial", redes_sociales: "Redes sociales", telefono: "Teléfono", referido: "Referido", otro: "Otro" };
export const canalLabel = (id) => {
  if (!id) return "—";
  if (CANAL_LABELS[id]) return CANAL_LABELS[id];
  const texto = String(id).replace(/_/g, " ");
  return texto.charAt(0).toUpperCase() + texto.slice(1);
};

/** Índice más avanzado del lead en el pipeline (perdidos usan la última etapa antes de perderse). */
export function alcanceLeadEnEmbudo(lead, etapas, historial = []) {
  const indice = (etapa) => (etapa && etapa !== "perdido" ? etapas.indexOf(etapa) : -1);
  if (lead.etapa !== "perdido") return indice(lead.etapa);
  return historial
    .filter((h) => h.leadId === lead.id)
    .reduce((max, h) => Math.max(max, indice(h.etapaAnterior), indice(h.etapaNueva)), -1);
}

/** Cada lead cuenta en su etapa y en todas las anteriores. */
export function funnelAcumulativo(etapasPipeline, leads, historial = [], ventasActivas = []) {
  const etapas = etapasPipeline.filter((e) => e !== "perdido");
  const alcances = leads.map((lead) => ({ lead, alcance: alcanceLeadEnEmbudo(lead, etapas, historial) }));
  return etapas.map((etapa, index) => {
    const leadsHastaAqui = alcances.filter((item) => item.alcance >= index).map((item) => item.lead);
    return {
      etapa,
      cantidad: leadsHastaAqui.length,
      oportunidad: valorEtapaEmbudo(etapa, leadsHastaAqui, ventasActivas),
      esVentasReales: etapa === ETAPA_VENTA_CERRADA,
    };
  });
}

/** Monto estimado en pipeline; en etapa venta cerrada, suma de ventas reales de esos clientes. */
export function valorEtapaEmbudo(etapa, leadsEnEtapa, ventasActivas = []) {
  if (etapa === ETAPA_VENTA_CERRADA) {
    const ids = new Set(leadsEnEtapa.map((l) => l.id));
    return Math.round(
      ventasActivas
        .filter((v) => v.leadId && ids.has(v.leadId))
        .reduce((s, v) => s + (Number(v.total) || 0), 0) * 100
    ) / 100;
  }
  return Math.round(
    leadsEnEtapa.reduce((s, l) => {
      const n = Number(l.montoEstimado);
      return s + (Number.isFinite(n) && n > 0 ? n : 0);
    }, 0) * 100
  ) / 100;
}

// Preserve IDs already referenced by leads, sales and stage history.
export function normalizarPipeline(config, leads = [], historial = []) {
  const anteriores = config.etapasPipeline || DEFAULT_STAGES;
  const catalogo = config.etapasCatalogo ? config.etapasCatalogo.map(e => ({ ...e })) : anteriores.map(id => ({ id, nombre: LABELS[id] || id, activa: true }));
  if (!config.etapasCatalogo && !catalogo.some(e => e.id === "propuesta_enviada")) {
    catalogo.splice(Math.max(0, catalogo.findIndex(e => e.id === "interesado") + 1), 0,
      { id: "propuesta_enviada", nombre: LABELS.propuesta_enviada, activa: true });
  }
  const referenciadas = [...DEFAULT_STAGES, ...anteriores, ...leads.map(l => l.etapa), ...historial.flatMap(h => [h.etapaAnterior, h.etapaNueva])];
  referenciadas.filter(Boolean).forEach(id => {
    if (!catalogo.some(e => e.id === id)) catalogo.push({ id, nombre: LABELS[id] || id, activa: false });
  });
  return { ...config, etapasCatalogo: catalogo, etapasPipeline: catalogo.filter(e => e.activa).map(e => e.id) };
}
